import { BehaviorSubject } from "rxjs";
import CookieStorage from "../../../utils/CookieStorage";
import { FILTER_STATE } from "../types/CommonTypes";
import { startOfDay, subDays } from "date-fns";

export const initialFilterState: FILTER_STATE = {
  dateRange: {
    from: startOfDay(subDays(new Date(), 6)),
    to: startOfDay(new Date()),
  },
  ots: [],
  procedureIds: [],
  attendingSurgeonNames: [],
  nurseIds: [],
  caseIds: [],
  otsKeys: [],
  procedureKeys: [],
  nurseKeys: [],
  assignedAnesthesiologist: [],
  caseStartDelay: [],
  anaesthelogistNameList: [],
  excludeOts: [],
  excludeProcedureIds: [],
  excludeAttendingSurgeonNames: [],
  excludeNurseIds: [],
  excludeAssignedAnesthesiologist: [],
  excludeDelayCategories: [],
  excludeCaseOrder: "",
  excludeCaseIds: [],
  excludeAutoClosed: "",
  caseOrder: "",
  autoClosed: "",
  inconsistentTimestamps: "",
  antibioticUsed: "",
  advanceFilters: [],
};


const filterState$ = new BehaviorSubject<FILTER_STATE>(initialFilterState);
CookieStorage.init("filterState", filterState$);

const filterCount$ = new BehaviorSubject<number>(0);
CookieStorage.init("filterCount", filterCount$);

export default filterState$;
export { filterCount$ };
